const initialState = null
export default (state = initialState, action) => {
    if (action.type.indexOf('_FAILED') !== -1) {
        return action.payload;
    }

    return state;
}
